// extracted by mini-css-extract-plugin
export default {"one-column":"ControlRadio-module__one-column__ikvMb","two-column":"ControlRadio-module__two-column__cQuo2"};